import { Injectable, Injector } from '@angular/core'
import {
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http'
import { Observable, throwError } from 'rxjs'
import { retry, catchError, finalize } from 'rxjs/operators'
import { Router } from '@angular/router'
import { LoaderService } from '@services/loader.service'
import { LoggingService } from '@services/logging.service'

export class HttpError {
  static badRequest = 400
  static unauthorized = 401
  static forbidden = 403
  static notFound = 404
  static timeOut = 408
  static conflict = 409
  static internalServerError = 500
  static gatewayTimeout = 504
}

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  timer: any

  constructor(
    private router: Router,
    public loaderService: LoaderService,
    private injector: Injector
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // get the logger
    const logger = this.injector.get(LoggingService)

    // timer for loader
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(() => this.loaderService.show(), 500)

    // catch all failures on HTTP and redirect or show a message box
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // create message
        const message =
          'Error from ServerErrorInterceptor: ' +
          error.status +
          ' - ' +
          error.statusText +
          ' --> ' +
          error.message

        // catch different states
        if (error.status === HttpError.badRequest) {
          logger.logError('BadRequest 400: ' + message)
          return throwError(error)
        } else if (error.status === HttpError.unauthorized) {
          logger.logError('Unauthorized 401: ' + message)
          // refresh token
          localStorage.clear()
          sessionStorage.clear()
          return throwError(error)
        } else if (error.status === HttpError.forbidden) {
          logger.logError('Forbidden 403: ' + message)
          return throwError(error)
        } else if (error.status === HttpError.notFound) {
          logger.logError('NotFound 404: ' + message)
          return throwError(error)
        } else if (error.status === HttpError.timeOut) {
          logger.logError('TimeOut 408: ' + message)
          return throwError(error)
        } else if (error.status === HttpError.conflict) {
          logger.logError('Conflict 409: ' + message)
          return throwError(error)
        } else if (error.status === HttpError.internalServerError) {
          logger.logError('InternalServerError 500: ' + message)
          this.router.navigate(['/error', error])
          return throwError(error)
        } else if (error.status === HttpError.gatewayTimeout) {
          logger.logError('Gateway Timeout 504: ' + message)
          this.router.navigate(['/error', error])
          return throwError(error)
        } else {
          return throwError(error)
        }
      }),
      finalize(() => {
        this.loaderService.hide()
        if (this.timer) {
          clearTimeout(this.timer)
        }
      })
    )
  }
}
